import React, { useEffect, useState } from 'react';
import NewsEventCard from '../components/NewsEventCard';
import axios from 'axios';
import Header from "../components/Header";
import Footer from "../components/Footer";
import eventsBanner from "../assets/img/events.jpg";
import YOD from "../assets/img/YOD Business Solutions Logo-Red.png";

const EventsPage = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchNewsEvents = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/news-events`);
        if (Array.isArray(res.data)) {
          setItems(res.data);
        } else {
          console.warn("Expected array, got:", res.data);
          setItems([]);
        }
      } catch (error) {
        console.error('Failed to fetch news/events:', error);
        setItems([]);
      }
    };

    fetchNewsEvents();
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid bg-light min-vh-100 pt-5">
        <div className="container py-5">
          <div className="text-center mb-5" data-aos="fade-up">
            <h1 className="display-4 mb-3" style={{ color: "#A71717" }}>
              Events & Opportunities
            </h1>
            <p className="lead text-muted">
              Stay updated with our latest events, programs, and opportunities to join our team or collaborate with us.
            </p>
          </div>
           <section className="py-5 bg-light" id="news-events">
      <div className="container">
      

        {/* EVENTS */}
        <h4 className="mb-3">
          {'Upcoming Events'}
        </h4>
        <div className="row g-4">
          {Array.isArray(items) &&
            items
              .filter((item) => item.type === 'Event')
              .map((item) => (
                <div className="col-md-6 col-lg-4" key={item.id}>
                  <NewsEventCard
                    {...item}
                    image={`${process.env.REACT_APP_API_URL}/uploads/${item.image}`}
                  />
                </div>
              ))}
        </div>

        {/* NEWS */}
        <h4 className="mt-5 mb-3">
          {'Latest News'}
        </h4>
        <div className="row g-4">
          {Array.isArray(items) &&
            items
              .filter((item) => item.type === 'News')
              .map((item) => (
                <div className="col-md-6 col-lg-4" key={item.id}>
                  <NewsEventCard
                    {...item}
                    image={`${process.env.REACT_APP_API_URL}/uploads/${item.image}`}
                  />
                </div>
              ))}
        </div>
      </div>
    </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default EventsPage;
